var _path, _path2, _rect, _g, _g2, _rect2, _g3, _g4, _ellipse, _g5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMysteryGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "115.1px",
    height: "105.9px",
    viewBox: "0 0 115.1 105.9",
    enableBackground: "new 0 0 115.1 105.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C428",
    d: "M85,105.2H31.3c-3.6,0-6.4-2.9-6.4-6.4V64.5c0-1,0.8-1.8,1.8-1.8h62.9c1,0,1.8,0.8,1.8,1.8v34.3 C91.5,102.4,88.6,105.2,85,105.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C428",
    d: "M93,45.3H22.9c-1.6,0-2.8,1.3-2.8,2.8v9.7c0,1.6,1.3,2.8,2.8,2.8H93c1.6,0,2.8-1.3,2.8-2.8v-9.7 C95.9,46.6,94.6,45.3,93,45.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.3,
    y: 44.3,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 9.8,
    height: 16.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00004C",
    d: "M65.5,71.6c1.6,1.4,2.4,3.4,2.4,6c0,2.4-0.8,4.2-2.3,5.6c-1.6,1.3-3.6,2-6.2,2L59.2,88h-5.7l-0.2-7h2.3 c1.9,0,3.4-0.2,4.5-0.7c1-0.5,1.5-1.4,1.5-2.6c0-0.9-0.2-1.6-0.7-2.1c-0.5-0.5-1.1-0.8-2-0.8c-0.9,0-1.6,0.3-2.1,0.8 c-0.5,0.5-0.8,1.2-0.8,2.1h-6.1c-0.1-1.5,0.3-2.9,1-4.2c0.7-1.2,1.7-2.2,3.1-2.9c1.4-0.7,3-1.1,5-1.1 C61.7,69.5,63.8,70.2,65.5,71.6z M53.7,96.9c-0.7-0.7-1.1-1.5-1.1-2.5c0-1,0.4-1.9,1.1-2.5c0.7-0.7,1.6-1,2.8-1c1.1,0,2,0.3,2.7,1 c0.7,0.7,1.1,1.5,1.1,2.5c0,1-0.4,1.8-1.1,2.5c-0.7,0.7-1.6,1-2.7,1C55.3,97.9,54.4,97.5,53.7,96.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8196 -0.5729 0.5729 0.8196 -9.5153 45.7168)",
    fill: "#FFFFFF",
    cx: 67.8,
    cy: 38,
    rx: 7.7,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00004C",
    d: "M72.1,32.7c0.9,0,1.7,0.3,2.1,0.8c1.1,1.6-0.9,4.8-4.4,7.3c-2.2,1.6-4.6,2.4-6.3,2.4 c-0.9,0-1.7-0.3-2.1-0.8c-1.1-1.6,0.9-4.8,4.4-7.3C68.1,33.6,70.4,32.7,72.1,32.7 M72.1,27.7c-2.8,0-6.1,1.2-9.1,3.3 c-6.1,4.3-8.4,10.2-5.6,14.2c0.8,1.1,2.6,3,6.2,3c2.8,0,6.1-1.2,9.1-3.3c2.3-1.6,4.2-3.5,5.3-5.5c2.7-4.4,1.1-7.6,0.3-8.7 C77.5,29.6,75.7,27.7,72.1,27.7L72.1,27.7z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 61.5,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 6.2,
    height: 44.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00004C",
    d: "M55.6,46.4c1.5-0.8,3-1.6,4.4-2.5c3.9,6.2,8.8,12.2,14.7,17.6c-1.5-0.1-3-0.2-4.5-0.4 c-0.1,1.2-0.2,2.5-0.3,3.7C64.1,59,59.3,52.8,55.6,46.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.8196 -0.5729 0.5729 -0.8196 65.843 97.1981)",
    fill: "#FFFFFF",
    cx: 48.2,
    cy: 38.2,
    rx: 7.7,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00004C",
    d: "M43.9,33c1.7,0,4,0.9,6.3,2.4c3.5,2.4,5.5,5.7,4.4,7.3c-0.4,0.6-1.1,0.8-2.1,0.8c-1.7,0-4-0.9-6.3-2.4 c-3.5-2.4-5.5-5.7-4.4-7.3C42.3,33.2,43,33,43.9,33 M43.9,28c-3.6,0-5.4,1.9-6.2,3c-2.9,4.1-0.6,9.9,5.6,14.2 c3,2.1,6.4,3.3,9.1,3.3c3.6,0,5.4-1.9,6.2-3c0.8-1.2,2.4-4.3-0.3-8.7c-1.2-2-3.1-3.9-5.3-5.5C50,29.2,46.7,28,43.9,28L43.9,28z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#00004C",
    cx: 58.1,
    cy: 44.6,
    rx: 5.5,
    ry: 5.4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00004C",
    d: "M60.5,46.5c-1.6-0.8-3.1-1.7-4.6-2.6c-3.9,6.2-8.9,12.1-14.8,17.4c1.6-0.1,3.1-0.2,4.7-0.3 c0.1,1.2,0.3,2.5,0.5,3.7C51.9,59,56.7,52.9,60.5,46.5z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 34.8,
    transform: "matrix(0.7495 -0.662 0.662 0.7495 -25.0037 13.1482)",
    fill: "#23B2FE",
    width: 4.5,
    height: 9.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 13.6,
    transform: "matrix(0.8663 0.4996 -0.4996 0.8663 20.3862 -39.3101)",
    fill: "#23B2FE",
    width: 4.5,
    height: 9.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 4.5,
    transform: "matrix(0.9469 -0.3216 0.3216 0.9469 -1.2372 11.172)",
    fill: "#23B2FE",
    width: 4.5,
    height: 9.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 2,
    transform: "matrix(0.8663 0.4996 -0.4996 0.8663 5.7096 -7.635)",
    fill: "#00D692",
    width: 4.5,
    height: 9.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4,
    y: 13.7,
    transform: "matrix(0.4176 0.9086 -0.9086 0.4176 44.0263 -31.5692)",
    fill: "#00D692",
    width: 4.5,
    height: 9.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 7.3,
    transform: "matrix(0.734 -0.6791 0.6791 0.734 18.6024 71.6461)",
    fill: "#00D692",
    width: 4.5,
    height: 9.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 0.2,
    transform: "matrix(0.9916 0.1296 -0.1296 0.9916 1.2946 -9.7395)",
    fill: "#B56EF5",
    width: 4.5,
    height: 9.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 26.7,
    transform: "matrix(0.8663 0.4996 -0.4996 0.8663 18.6807 -6.7423)",
    fill: "#B56EF5",
    width: 4.5,
    height: 9.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 40.7,
    transform: "matrix(0.3759 -0.9267 0.9267 0.3759 26.3805 130.1508)",
    fill: "#B56EF5",
    width: 4.5,
    height: 9.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 16.9,
    transform: "matrix(0.5717 0.8205 -0.8205 0.5717 22.3464 0.8035)",
    fill: "#FF6577",
    width: 4.3,
    height: 9.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 7.3,
    transform: "matrix(0.9879 -0.1551 0.1551 0.9879 -1.1437 9.5026)",
    fill: "#FF6577",
    width: 4.5,
    height: 9.6
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 28.5,
    transform: "matrix(0.8676 -0.4972 0.4972 0.8676 -3.9855 51.7555)",
    fill: "#FF6577",
    width: 4.5,
    height: 9.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysteryGift);
export default __webpack_public_path__ + "static/media/mystery-gift.688364387e37d2456bacc57882218ee6.svg";
export { ForwardRef as ReactComponent };